(function () {
  "use strict";

  var guide = window.LP_JAR_GUIDE;
  var root = document.querySelector("[data-lp-dimensions-guide]");
  if (!guide || !root) return;

  var state = { familyId: "super", productId: "super-1000" };

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function familyById(id) { return guide.families.find(function (item) { return item.id === id; }); }
  function productById(id) { return guide.products.find(function (item) { return item.id === id; }); }
  function productsForFamily(id) { return guide.products.filter(function (item) { return item.familyId === id; }); }
  function inches(mm) { return mm == null ? null : (mm / 25.4).toFixed(2) + " in"; }
  function ounces(g) { return g == null ? null : (g / 28.349523125).toFixed(1) + " oz"; }
  function fluidOunces(ml) { return ml == null ? null : (ml / 29.5735295625).toFixed(1) + " US fl oz"; }

  function dimensionSpec(label, value, conversion) {
    if (value == null || value === "") {
      return '<div class="lp-spec lp-spec-empty"><span class="lp-spec-label">' + escapeHtml(label) + '</span><span class="lp-spec-value">Not available</span></div>';
    }
    return '<div class="lp-spec"><span class="lp-spec-label">' + escapeHtml(label) + '</span><span class="lp-spec-value">' + escapeHtml(value) + '</span>' + (conversion ? '<span class="lp-spec-us">' + escapeHtml(conversion) + '</span>' : '') + '</div>';
  }

  function familyCards() {
    return guide.families.map(function (family) {
      var selected = family.id === state.familyId;
      var imageMarkup = family.heroImages && family.heroImages.length ?
        '<span class="lp-family-card-image lp-family-card-image-group">' + family.heroImages.map(function (src, index) {
          return '<img src="' + escapeHtml(src) + '" alt="' + (index === 0 ? escapeHtml(family.heroImageAlt) : '') + '" loading="lazy">';
        }).join("") + '</span>' :
        '<span class="lp-family-card-image"><img src="' + escapeHtml(family.heroImage) + '" alt="' + escapeHtml(family.heroImageAlt) + '" loading="lazy"></span>';
      return '<button class="lp-family-card" type="button" data-family-id="' + escapeHtml(family.id) + '" aria-pressed="' + selected + '">' +
        imageMarkup +
        '<span class="lp-family-card-copy"><span class="lp-family-card-title">' + escapeHtml(family.name) + '</span><span class="lp-family-card-description">' + escapeHtml(family.description) + '</span></span>' +
      '</button>';
    }).join("");
  }

  function capacityOptions() {
    return productsForFamily(state.familyId).map(function (product) {
      return '<option value="' + escapeHtml(product.id) + '"' + (product.id === state.productId ? " selected" : "") + '>' + escapeHtml(product.capacityLabel) + '</option>';
    }).join("");
  }

  function replacementMarkup(product) {
    if (!product.replacementParts.length) return '<span class="lp-no-part">Not currently sold separately</span>';
    return product.replacementParts.map(function (item) {
      return '<a class="lp-replacement-link" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.label) + '</a>';
    }).join('<span class="lp-link-divider" aria-hidden="true"> · </span>');
  }

  function useMarkup(product) {
    return product.uses.map(function (item) {
      return '<a class="lp-use-link" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.label) + '</a>';
    }).join("");
  }

  function cartMarkup(product) {
    if (!product.available) return '<button class="lp-button lp-button-secondary" type="button" disabled>Currently unavailable</button>';
    return '<form class="lp-cart-form" method="post" action="' + escapeHtml(guide.meta.storeUrl) + '/cart/add">' +
      '<input type="hidden" name="id" value="' + escapeHtml(product.variantId) + '">' +
      '<input type="hidden" name="quantity" value="1">' +
      '<input type="hidden" name="return_to" value="/cart">' +
      '<button class="lp-button lp-button-secondary" type="submit">Add to cart</button>' +
    '</form>';
  }

  function resultMarkup() {
    var family = familyById(state.familyId);
    var product = productById(state.productId);
    var stackable = product.stackable == null ? null : (typeof product.stackable === "boolean" ? (product.stackable ? "Yes" : "No") : product.stackable);

    return '<article class="lp-result" aria-live="polite">' +
      '<div class="lp-product-visual">' +
        '<img src="' + escapeHtml(product.variantImage) + '" alt="' + escapeHtml(product.variantImageAlt) + '">' +
        '<div class="lp-product-visual-label"><strong>' + escapeHtml(family.name) + '</strong><span>' + escapeHtml(product.capacityLabel) + '</span><p class="lp-product-visual-description">' + escapeHtml(family.description) + '</p></div>' +
        '<div class="lp-actions">' +
          '<a class="lp-button" href="' + escapeHtml(product.productUrl) + '">Shop this jar</a>' + cartMarkup(product) +
        '</div>' +
        '<div class="lp-uses"><h4>Recommended uses &amp; inspiration</h4><div class="lp-use-links">' + useMarkup(product) + '</div></div>' +
      '</div>' +
      '<div class="lp-result-content">' +
        '<p class="lp-result-kicker">Official dimensions</p>' +
        '<h3>' + escapeHtml(product.capacityLabel) + ' ' + escapeHtml(family.name) + '</h3>' +
        '<div class="lp-spec-grid">' +
          dimensionSpec("Height", product.heightMm == null ? null : product.heightMm + " mm", inches(product.heightMm)) +
          dimensionSpec("Maximum width", product.maxWidthMm == null ? null : product.maxWidthMm + " mm", inches(product.maxWidthMm)) +
          dimensionSpec("Width at bottom", product.bottomWidthMm == null ? null : product.bottomWidthMm + " mm", inches(product.bottomWidthMm)) +
          dimensionSpec("Interior width at opening", product.openingMm == null ? null : product.openingMm + " mm", inches(product.openingMm)) +
          dimensionSpec("Stackable?", stackable, null) +
          dimensionSpec("Empty weight", product.emptyWeightG == null ? null : product.emptyWeightG + " g", ounces(product.emptyWeightG)) +
          dimensionSpec("Canning / Max-fill capacity", product.maxFillMl == null ? null : product.maxFillMl + " mL", fluidOunces(product.maxFillMl)) +
          dimensionSpec("Brim-full capacity", product.brimFullMl == null ? null : product.brimFullMl + " mL", fluidOunces(product.brimFullMl)) +
        '</div>' +
        '<div class="lp-details-panel">' +
          '<div class="lp-detail-item"><span>Closure system</span><strong>' + escapeHtml(family.closure) + '</strong></div>' +
          '<div class="lp-detail-item"><span>Replacement parts</span><div class="lp-replacement-links">' + replacementMarkup(product) + '</div></div>' +
        '</div>' +
      '</div>' +
    '</article>';
  }

  function heading(number, title, description, id) {
    return '<div class="lp-step-heading"><span class="lp-step-number">' + number + '</span><div><h2 id="' + id + '">' + escapeHtml(title) + '</h2>' + (description ? '<p>' + escapeHtml(description) + '</p>' : '') + '</div></div>';
  }

  function render() {
    root.innerHTML = '<section class="lp-guide" aria-labelledby="lp-family-heading">' +
      heading("1", "Match your jar style", "Use the product-family image and body shape to identify your jar.", "lp-family-heading") +
      '<div class="lp-family-grid" role="group" aria-label="Jar style">' + familyCards() + '</div>' +
      '<div class="lp-capacity-section" aria-labelledby="lp-capacity-heading">' +
        heading("2", "Choose your capacity", "", "lp-capacity-heading") +
        '<div class="lp-capacity-row"><div class="lp-field"><label for="lp-capacity">Capacity</label><select class="lp-capacity-select" id="lp-capacity">' + capacityOptions() + '</select></div><p>Measurements update automatically in metric and U.S. customary units.</p></div>' +
      '</div>' +
      '<div data-result>' + resultMarkup() + '</div>' +
    '</section>';
    bindEvents();
  }

  function updateResult() {
    var result = root.querySelector("[data-result]");
    if (result) result.innerHTML = resultMarkup();
  }

  function bindEvents() {
    root.querySelectorAll("[data-family-id]").forEach(function (button) {
      button.addEventListener("click", function () {
        state.familyId = button.getAttribute("data-family-id");
        state.productId = productsForFamily(state.familyId)[0].id;
        render();
        window.requestAnimationFrame(function () {
          var capacitySection = root.querySelector(".lp-capacity-section");
          var capacitySelect = root.querySelector("#lp-capacity");
          if (capacitySelect) capacitySelect.focus({ preventScroll: true });
          if (capacitySection) capacitySection.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block: "start" });
        });
      });
    });
    var select = root.querySelector("#lp-capacity");
    if (select) select.addEventListener("change", function () { state.productId = select.value; updateResult(); });
  }

  render();
})();
